module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3r1n2n-411afacfa55061990207ab101a22f441.svg";